<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter && panel_required">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>Letterplate Cowl: </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Choose Letterplate Cowl:';
                }
            },
            component_id: {
                default(){
                    return 'hardware_letterbox_cowl';
                }
            },
            hardwareColour: {
                required: true
            },
            hardwareLetterplate: {
                required: true
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
            doorLocation: {
                default(){
                    return '1';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareLetterplate, this.hardwareColour, this.securedByDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/letterplate-cowl?letterplate=' + this.hardwareLetterplate + '&hardware_colour=' + this.hardwareColour + '&secured_by_design=' + this.securedByDesign + '&door_location=' + this.doorLocation;
            },
            cache_key(){
                return '_' + this.hardwareLetterplate + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.doorLocation;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
